import React from 'react';
import SharedNavbarTop from 'shared_items/NavbarTop';

// Wrapper de compatibilidade — preserva a assinatura original (activeTab, toggle settings/notes).
// Implementação real em shared_items/NavbarTop.jsx (design-system fase 3b). Remover em fase 4.
// NOTA: o botão do logo no arquivo original usava bg-yellow-600 (tingido pelo módulo) em vez do
// bg-gray-800 universal que todos os outros módulos usam — normalizado aqui pro padrão comum.
// Mudança visual mínima e intencional, ver docs/design-system/decisions.md.
const NavbarTop = ({ title, onHomeClick, onLogoutClick, handleTabChange, activeTab }) => {
  const showBackButton = activeTab === 'settings';
  return (
    <SharedNavbarTop
      title={title}
      moduleKey="notepad"
      onHomeClick={onHomeClick}
      zIndexClass="z-50"
      settingsActive={showBackButton}
      onSettingsClick={() => handleTabChange(showBackButton ? 'notes' : 'settings')}
    />
  );
};

export default NavbarTop;
